import createFireAndForgetEmitter from 'lib/utils/FireAndForgetEmitter';

const emitter = createFireAndForgetEmitter();

export default emitter;
